import React, { useEffect } from 'react';
import CustomDialog from '../../../shared/components/CustomDialog/CustomDialog';
import Button from '../../../shared/components/Button/Button';
import styles from './WarehouseSelectModal.module.scss';
import { defaultLimit, defaultPage } from '../../../app/conf';


const defaultFilters = {
    full_company: 1,
    limit: defaultLimit,
    page: defaultPage,
    enabled: 'true',
    type: ['device'] 
};

export default function WarehouseSelectModal({ 
  open, 
  onClose, 
  onContinue, 
  selected, 
  setSelected, 
  filtersToUseInQuery,
  getStoresRequest, 
  loading, 
  disableContinue = false,
  continueButtonTooltip = '',
  editFetching = false,
  store: { stores, getFetching, total, submitFetching, error } }) {
  
   useEffect(() => {
 
          const filters = {
              ...defaultFilters,
              ...filtersToUseInQuery
          };
          

          if (filtersToUseInQuery && filtersToUseInQuery.type && !Array.isArray(filtersToUseInQuery.type)) {
              filters.type = [filtersToUseInQuery.type];
          }

          getStoresRequest(filters); 
      }, [getStoresRequest, filtersToUseInQuery]);


  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      minWidth={1024}
      maxWidth={1024*3}
      dialogTitle="Asignar bodega"
      dialogSubTitle="Selecciona la bodega física a la que quieres asignar este lote"
      dialogActions={
        <>
        
          <Button
            variant="primary"
            onClick={onContinue}
            disabled={selected === null || loading || disableContinue || editFetching} 
            title={editFetching ? 'Asignando bodega...' : continueButtonTooltip}
          >
            {editFetching ? (
              <>
                <span>Asignando bodega...</span>
                <span className={styles.spinner} style={{ marginLeft: '8px' }}></span>
              </>
            ) : loading ? (
              <>
                <span>Procesando...</span>
                <span className={styles.spinner} style={{ marginLeft: '8px' }}></span>
              </>
            ) : 'Cargar'} 
          </Button>
         
        </>
      }
    >
    {disableContinue && !loading && !editFetching && (
  <div className={styles.processingMessage}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={styles.iconClock}
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="currentColor"
    >
      <path d="M12 1.75C6.07 1.75 1.25 6.57 1.25 12.5S6.07 23.25 12 23.25 22.75 18.43 22.75 12.5 17.93 1.75 12 1.75zm0 20c-4.97 0-9-4.03-9-9s4.03-9 9-9 
      9 4.03 9 9-4.03 9-9 9zm.5-13h-1v5.25l4.5 2.67.5-.87-4-2.3V8.75z"/>
    </svg>
    <div className={styles.messageText}>
    Procesando la información. Podrás continuar cuando la carga de datos finalice. 
    </div>
  </div>
)}

      <div className={styles.list}>
        {stores.map((w, i) => (
          <label key={w._id || i} className={styles.option}>
            <input
              type="radio"
              name="warehouse"
              checked={selected && selected._id === w._id ? true : false}
              onChange={() => setSelected(w)}
            />
            <span className={styles.radio}></span>
            <span>{w.name}</span>
          </label>
        ))}
      </div>
    </CustomDialog>
  );
}
